<template>
  <div id="tableau" class="dashboard frame">
    <v-row>
      <iframe src="https://data.airfinder.com/views/211b8622-46b2-45f2-9efb-491cdd6a64af/Home/webpage/53aeddaa-0eb8-4f91-8718-b5779ce55ef6?:display_count=n&:showVizHome=n&:origin=viz_share_link&:embed=yes&:tabs=yes&:toolbar=yes" 
      width="1080" height="800"></iframe>
    </v-row>
  </div>
</template>
<script>
export default {};
</script>

<style lang="scss" scoped>
.dashboard {
  padding: 0 30px;
  height: calc(100vh - 96px);
  overflow: auto;
}

.frame iframe {
  width: 100%;
}
</style>